<template>
  <el-card shadow="never">
    <template #header>
      <div class="card-header">
        <el-page-header @back="goBack">
          <template #content>
            <span class="text-large font-600 mr-3"> 反馈 </span>
          </template>
        </el-page-header>
      </div>
    </template>
    <div>
      <el-form :model="searchData" inline label-width="80px">
        <el-form-item label="时间">
          <el-date-picker
            v-model="searchData.addtime"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="请选择时间"
          />
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="searchData.words" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
  <el-card shadow="never" style="margin-top:20px">
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="id" label="id" width="55" />
      <el-table-column prop="name" label="会员" width="100" />
      <el-table-column prop="content" label="留言" />
      <el-table-column prop="addTime" label="添加时间" width="160" />
      <el-table-column label="状态" width="80">
        <template #default="scope">
          {{scope.row.status==1?'已查阅':'未查阅'}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button size="small" @click="checkfeedback(scope.row.id)">查阅</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delfeedback(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="float:right;margin:20px">
      <el-pagination
        v-model:currentPage="current_page"
        v-model:page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-card>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { ElMessage } from 'element-plus'
import api from '@/api/index.js'
export default defineComponent({
setup() {
  const searchData = ref({
    words:'',
    addtime:'',
    page:1,
  })
  const handleSelectionChange = () => {
    console.log('go back')
  }
  const tableData = ref([])
  const pageSize = ref(10)
  const total = ref(0)
  const current_page = ref(1)
  return {
    tableData,
    searchData,
    pageSize,
    total,
    current_page,
    handleSelectionChange
  };
},
methods: {
  goBack(){
    this.$router.go(-1)
  },
  handleCurrentChange(val){
    this.searchData.page = val
    this.getList()
  },
  deleteLevel(id){
    let that = this
    api.memberApi.deleteLevel({id:id}).then(res => {
        if (res.code === 0) {
          ElMessage({
            message: res.message,
            type: 'success',
          })
          that.getList()
        }else{
          ElMessage.error(res.message)
        }
    }).catch((res) => {
        ElMessage.error(res.message);
    })
  },
  search(){
    this.searchData.page=1
    this.getList()
  },
  getList(){
    let that = this
    api.feedbackApi.getList(this.searchData).then(res => {
        if (res.code === 0) {
          that.pageSize = res.data.per_page
          that.tableData = res.data.data
          that.total = res.data.total
          that.current_page = res.data.current_page
        }else{
          ElMessage.error(res.message)
        }
    }).catch((res) => {
        ElMessage.error(res.message);
    })
  },
  checkfeedback(id){
    let that = this
    api.feedbackApi.checkfeedback({id:id}).then(res => {
        if (res.code === 0) {
            ElMessage({
              message: res.message,
              type: 'success',
            })
            that.getList()
        }else{
          ElMessage.error(res.message)
        }
    }).catch((res) => {
        ElMessage.error(res.message);
    })
  },
  delfeedback(id){
    let that = this
    api.feedbackApi.delfeedback({id:id}).then(res => {
        if (res.code === 0) {
            ElMessage({
              message: res.message,
              type: 'success',
            })
            that.getList()
        }else{
          ElMessage.error(res.message)
        }
    }).catch((res) => {
        ElMessage.error(res.message);
    })
  },
},
mounted () {
  this.getList()
}
})
</script>
<style>

</style>